import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import "../SignupPages/SignupCommon.css";
import rectangleGraph from "../../assets/images/Rectangle-graph.png";

const IntakeFormPage12: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const completeIntakeStep8 = localStorage.getItem("complete-intake-step8");
    if (completeIntakeStep8) {
      navigate("/complete-intake/step-9", { replace: true });
    } else {
      navigate("/complete-intake/step-8", { replace: true });
    }
  }, []);

  const handleNext = () => {
    navigate("/complete-intake/step-10");
    localStorage.setItem("complete-intake-step9", "true");
  };

  return (
    <PageWrapper>
      <div>
        <div className="signup-page-container container">
          <div className="signup-content">
            <p
              className="curved-journey-content"
              style={{ textAlign: "center" }}
            >
              It feels like magic, but it’s{" "}
              <span className="content-color">metabolic science.</span>
            </p>
            <div className="graphContainer">
              <img src={rectangleGraph} alt="Graph" />
            </div>

            <div
              style={{ paddingTop: "20px", paddingBottom: "20px" }}
              className="clinical-trails-div"
            >
              <span className="clinical-content">
                In clinical trails, GLP-1 patients{" "}
                <span style={{ fontWeight: "700" }}>
                  lost 18% of their body weight.
                </span>
              </span>
              <br></br>
              <br></br>
              <span className="clinical-content">
                Non-branded medications offer the{" "}
                <span style={{ fontWeight: "700" }}>
                  same active ingredient
                </span>{" "}
                as Wegovy®, Ozempic®, Zepbound® and Mounjaro® — but at a
                fraction of the price (80% less) and are more consistently
                available.
              </span>
            </div>
            <button onClick={handleNext} className="next-btn sticky-btn">
              Continue →
            </button>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default IntakeFormPage12;
